// extracted by mini-css-extract-plugin
export default {"form":"Form_form__jVtlK","error":"Form_error__Cv3Fp","light":"Form_light__hsmTk","dark":"Form_dark__4MqHE"};